import { ContactOptions } from '../../../../Model/Lead';

const texts = {
  contactOptions: {
    [ContactOptions.EMAIL]: 'Email - {contact}',
    [ContactOptions.iMessage]: 'Text/iMessage - {contact}',
  },
  sendOnboardingLink: 'Send Onboarding Link',
  selectOption: 'Select Option',
  success: 'Contract sent successfully',
  fail: 'Failed to send a contract. {error}',
  messageBodyRequired: 'Message body is required',
  emailSubjectRequired: 'Email subject is required',
  onboardingLinkRequired: 'Onboarding link is required in the message body',
};

export default texts;
